import React, { useState, useContext, useEffect } from "react";
import "react-dropdown/style.css";
import axios from "axios";
import Avatar from "@material-ui/core/Avatar";
import AccountCircleSharpIcon from "@material-ui/icons/AccountCircleSharp";
import PaymentIcon from "@material-ui/icons/Payment";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import Icon from "@material-ui/core/Icon";
import Alert from "@material-ui/lab/Alert";
import { toast } from "react-toastify";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Row,
  Col,
  Card,
  CardBody,
  Progress,
  Label,
} from "reactstrap";
import "../css/course-catelog.css";
import "../css/landing.css";
import { Link } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import logo from "../assets/images/eduplusnow.jpg";
import NotificationsIcon from "@material-ui/icons/Notifications";
//import HelpIcon from '@mui/icons-material/Help';
import HelpIcon from '@material-ui/icons/Help';
import FavoriteIcon from "@material-ui/icons/Favorite";
import HomeIcon from "@material-ui/icons/Home";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import Badge from "@material-ui/core/Badge";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Notification from "../pages/Learner/Notification.js";
import HelpVideotab from "../pages/Learner/Notification.js";
const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);
// import { toast } from "react-toastify";
const Header = () => {
  const context = useContext(UserContext);
  const [collapsed, setCollapsed] = useState(true);
  const toggleNavbar = () => setCollapsed(!collapsed);
  const toggle = () => setIsOpen(!isOpen);
  const [finalcatagorylist, setCtlist] = useState([]);
  const [mycourselist, setMycourselist] = useState([]);
  const [profdetailscalculaton, setprofdetailscalculaton] = useState(0);
  const [notification, setNotification] = useState(0);
  const [profile, setProfile] = useState("");
  const [dropdownOpen, setOpen] = useState(false);
  const [dropdownOpenProfile, setOpenProfile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isinstallment, setIsInstallment] = useState(false);
  useEffect(() => {
    // Update the document title using the browser API
    if (context?.user?.email) {
      getCoursecatelog();
    }
  }, [context?.user?.email]);
  const defaultProps = {
    color: "error",
    children: <NotificationsIcon />,
  };
  const getCoursecatelog = async () => {
    axios
      .post("Sample/courseCatelog")
      .then((res) => {
        if (res.data.status === "200") {
          setCtlist(res.data.finalcatagorylist);
          setMycourselist(res.data.mycourselist);
          setNotification(res.data.notificationsize);
          setprofdetailscalculaton(res.data.profdetailscalculaton);
          setProfile(res.data.profile);
          setIsInstallment(res.data.installment);
          // localStorage.setItem("notification",res.data.notificationsize)
          // context.setUser({ email: localStorage.getItem("user"), token: localStorage.getItem("token") ,notification:res.data.notificationsize})
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const toastmsg = (msg) => {
    toast.error(msg, {
      position: toast.POSITION.TOP_CENTER,
    });
    setIsOpen(false);
    setOpen(!dropdownOpen);
  };
  const toggle1 = () => {
    // console.log("dropdownOpen  =" + dropdownOpen);
    setOpen(!dropdownOpen);
  };
  const closedropdown = () => {
    // console.log("closedropdown  =" + dropdownOpen);
    setOpen(!dropdownOpen);
  };

  const toggleprofile = () => {
    // console.log("dropdownOpenProfile  =" + dropdownOpenProfile);
    setOpenProfile(!dropdownOpenProfile);
  };
  const closeNav = () => {
    setIsOpen(false);
    setOpen(!dropdownOpen);
  };
  const closedropdownprofile = () => {
    // console.log("dropdownOpenProfile  =" + dropdownOpenProfile);
    setOpenProfile(!dropdownOpenProfile);
    setIsOpen(false);
  };

  return (
    <Navbar light expand="md" toggleable>
      <NavbarBrand>
        <Link to="/">
          <img src={logo} height="50" alt="Logo" />
        </Link>
      </NavbarBrand>
      <NavbarToggler onClick={toggle} className="mr-2" />
      <Collapse isOpen={isOpen} navbar>
        <Nav
          class="navbar navbar-expand-md navbar-light bg-light ml-auto "
          navbar
        >
          {context.user?.email ? (
            <>
              {isinstallment ? (
                <NavItem>
                <Link
                  to={{
                    pathname: "/pay-installment",
                  }}
                >
                  <button
                    className=" bg-edu nav-link course-link"
                    caret
                  >
                    Pay Installment
                  </button>
                </Link>
               </NavItem>
              ) : (
                ""
              )}
              <NavItem className="nav-link">
              <Tooltip title="Home"  aria-label="add Event"><Link onClick={closeNav} to="/">
                  <HomeIcon />
                </Link></Tooltip>
              </NavItem>
              <NavItem className="nav-link">
                <UncontrolledDropdown setActiveFromChild>
                  <DropdownToggle
                    tag="a"
                    className="bg-edu  course-link dropdown-toggle "
                    caret
                  >
                    Course Catalog
                  </DropdownToggle>
                  <DropdownMenu
                    style={{
                      margin: "0px",
                      padding: "0px",
                      marginBottom: "-2px",
                      paddingBottom: "-2px",
                    }}
                  >
                    {finalcatagorylist.map((item, indexitem) => {
                      return (
                        <>
                          <Dropdown direction="left">
                            <DropdownToggle
                              tag="a"
                              className="headewe nav-link coursecat-link dropdown-toggle"
                            >
                              <span className="dropdowntogglename">
                                {item.catagoryname}
                              </span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdownitem1">
                              <div id="style-6" class="desc scrollbarc">
                                <span class="force-overflowc">
                                  {item.courseslist.map((itemc, indexitemc) => {
                                    return (
                                      <>
                                        <div className="coursecat1">
                                          <Card className="programItemStacked1">
                                            <Link
                                              onClick={closeNav}
                                              to={{
                                                pathname:
                                                  "/Explore/" +
                                                  itemc.staticlink,
                                                params: {
                                                  courseid: itemc.courseid,
                                                },
                                              }}
                                            >
                                              <div class="flex-container">
                                                <div>
                                                  <img
                                                    className="imgcatalog"
                                                    id="blah"
                                                    src={itemc.crsimage}
                                                    alt=""
                                                  />
                                                </div>
                                                <div className="ProgramItemStacked1__details">
                                                  <div class="font-nav-text-big">
                                                    {" "}
                                                    {itemc.coursename}
                                                  </div>
                                                </div>
                                              </div>
                                            </Link>
                                          </Card>
                                        </div>
                                      </>
                                    );
                                  })}
                                </span>
                              </div>
                            </DropdownMenu>
                          </Dropdown>
                        </>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </NavItem>
              <NavItem className="nav-link">
                <Dropdown direction="down">
                  <DropdownToggle
                    tag="a"
                    className="bg-edu  course-link  dropdown-toggle"
                    caret
                  >
                    My Learning
                  </DropdownToggle>
                  <DropdownMenu className="dropdownitem1">
                    {" "}
                    {mycourselist.length === 0 ? (
                      <>
                        <div className="coursecat1">
                          <Alert severity="warning">
                            <b>No Course is purchased </b>
                          </Alert>
                        </div>
                      </>
                    ) : (
                      <>
                        <div id="style-6" class="desc scrollbarc">
                          <span class="force-overflowc">
                            {mycourselist.map((item, indexitem) => {
                              return (
                                <>
                                  <div className="coursecat1">
                                    {item.ispersonal_details_required ===
                                      true && profdetailscalculaton != 100 ? (
                                      <Link
                                        onClick={() =>
                                          toastmsg(
                                            "Please click on view course button on corrosponding course card on home page and fill the required details.."
                                          )
                                        }
                                      >
                                        <Card
                                          style={{
                                            width: "300px",
                                            border: "1px solid #222",
                                            padding: "0.1px",
                                          }}
                                        >
                                          <CardBody>
                                            <div class="flex-container">
                                              <div>
                                                <img
                                                  className="mycourselist-img"
                                                  id="blah"
                                                  src={item.crsimage}
                                                  alt=""
                                                />
                                              </div>

                                              <div className="ProgramItemStacked1__details">
                                                <div class="font-nav-text-big">
                                                  <Label>
                                                    {item.coursename}
                                                  </Label>
                                                  <br />

                                                  <Progress
                                                    animated
                                                    color=""
                                                    value={item.percentComplete}
                                                  >
                                                    {item.percentComplete}
                                                  </Progress>
                                                </div>
                                              </div>
                                            </div>
                                          </CardBody>
                                        </Card>
                                      </Link>
                                    ) : (
                                      <>
                                        {item.iscourseblocked ? (
                                          <Link
                                            onClick={() =>
                                              toastmsg(
                                                "Please Pay installment to access course"
                                              )
                                            }
                                          >
                                            <Card
                                              style={{
                                                width: "300px",
                                                border: "1px solid #222",
                                                padding: "0.1px",
                                              }}
                                            >
                                              <CardBody>
                                                <div class="flex-container">
                                                  <div>
                                                    <img
                                                      className="mycourselist-img"
                                                      id="blah"
                                                      src={item.crsimage}
                                                      alt=""
                                                    />
                                                  </div>

                                                  <div className="ProgramItemStacked1__details">
                                                    <div class="font-nav-text-big">
                                                      <Label>
                                                        {item.coursename}
                                                      </Label>
                                                      <br />

                                                      <Progress
                                                        animated
                                                        color=""
                                                        value={
                                                          item.percentComplete
                                                        }
                                                      >
                                                        {item.percentComplete}
                                                      </Progress>
                                                    </div>
                                                  </div>
                                                </div>
                                              </CardBody>
                                            </Card>
                                          </Link>
                                        ) : (
                                          <Link
                                            onClick={closeNav}
                                            to={{
                                              state: {
                                                coflearner: item.coflearner,
                                              },
                                              pathname: item.staticlink,
                                            }}
                                          >
                                            <Card
                                              style={{
                                                width: "300px",
                                                border: "1px solid #222",
                                                padding: "0.1px",
                                              }}
                                            >
                                              <CardBody>
                                                <div class="flex-container">
                                                  <div>
                                                    <img
                                                      className="mycourselist-img"
                                                      id="blah"
                                                      src={item.crsimage}
                                                      alt=""
                                                    />
                                                  </div>

                                                  <div className="ProgramItemStacked1__details">
                                                    <div class="font-nav-text-big">
                                                      <Label>
                                                        {item.coursename}
                                                      </Label>
                                                      <br />

                                                      <Progress
                                                        animated
                                                        color=""
                                                        value={
                                                          item.percentComplete
                                                        }
                                                      >
                                                        {item.percentComplete}
                                                      </Progress>
                                                    </div>
                                                  </div>
                                                </div>
                                              </CardBody>
                                            </Card>
                                          </Link>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </>
                              );
                            })}
                          </span>
                        </div>
                      </>
                    )}
                  </DropdownMenu>
                </Dropdown>
              </NavItem>
              {/* <NavItem>
              <NavLink >
              <FavoriteIcon />
              </NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink tag={Link} to="/Learner/notification/view-all">
                  <NotificationsIcon />
                  <span class="num">
                    {notification > 0 ? notification : ""}
                   
                  </span>
                </NavLink>
              </NavItem>
              &nbsp;&nbsp; */}
              <NavItem className="nav-link">
              <Tooltip title="Help"  aria-label="add Event">
                    <Link onClick={closeNav} to="/HelpVideotab">
               <HelpIcon /> 
                </Link></Tooltip>
              </NavItem>
               
              <NavItem className="nav-link">
                <UncontrolledDropdown>
                  <div className="course-link noti-mob">
                    {notification === 0 ? (
                      <>
                        <Badge max={99} {...defaultProps} />
                      </>
                    ) : (
                      <>
                        <Badge
                          badgeContent={notification > 0 ? notification : ""}
                          max={99}
                          {...defaultProps}
                        />
                      </>
                    )}
                  </div>
                  <DropdownMenu className="notif-align">
                    <div id="style-6" class="desc scrollbarnotf">
                      <span class="force-overflownotf">
                        <Notification />
                      </span>
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </NavItem>
              &nbsp;&nbsp; &nbsp;&nbsp;
              <UncontrolledDropdown className="avtar-set" setActiveFromChild>
                {profile !== "NA" ? (
                  <Avatar alt={localStorage.getItem("initial")} src={profile} />
                ) : (
                  <StyledBadge
                    overlap="circle"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    variant="dot"
                  >
                    <Avatar> {localStorage.getItem("initial")}</Avatar>
                  </StyledBadge>
                )}
                {/* <button
                  type="button"
                  className="btn btn-light btn-circle btn-xl"
                  id="cart"
                >
                  {localStorage.getItem("initial")}
                </button> */}
                <DropdownMenu className="avtar-align ">
                  <div id="style-6" class="desc scrollbarp">
                    <span class="force-overflowp">
                      <Row className="container">
                        <Col xs="2" sm="12" md="2">
                          {profile !== "NA" ? (
                            <Avatar
                              alt={localStorage.getItem("initial")}
                              src={profile}
                              style={{ width: "60px", height: "60px" }}
                            />
                          ) : (
                            <span className="btn btn-light btn-circle-av btn-xl">
                              {localStorage.getItem("initial")}
                            </span>
                          )}
                        </Col>
                        <Col xs="7" sm="12" md="7">
                          <div id="profile-name">
                            {localStorage.getItem("name")}
                          </div>
                        </Col>
                      </Row>

                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/profile"
                        onClick={closedropdownprofile}
                      >
                        <span className="pro-text-nav">
                          <img
                            width="30"
                            height="30"
                            src="/assets/images/icons/bprofile.svg"
                          />

                          {/* <AccountCircleSharpIcon className="icon-p" /> */}
                          <span className="icon-p12">profile</span>
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/transaction"
                        onClick={closedropdownprofile}
                      >
                        <span className="pro-text-nav">
                          {" "}
                          <PaymentIcon className="icon-p" />
                          My Transaction
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/myskill"
                        onClick={closedropdownprofile}
                      >
                        <img
                          width="25"
                          height="25"
                          src="/assets/images/my_skill.svg"
                        />
                        {/* <EmojiEventsIcon className="icon-p" /> */}
                        <span className="pro-text-nav icon-p1">My Skill</span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/mycertificate"
                        onClick={closedropdownprofile}
                      >
                        <img
                          width="30"
                          height="30"
                          src="/assets/images/icons/certificate.svg"
                        />
                        {/* <CardMembershipIcon className="icon-p" /> */}
                        <span className="pro-text-nav icon-p12">
                          My Certificate
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/mygradesheet"
                        onClick={closedropdownprofile}
                      >
                        <img
                          width="30"
                          height="30"
                          src="/assets/images/icons/certificate.svg"
                        />
                        {/* <CardMembershipIcon className="icon-p" /> */}
                        <span className="pro-text-nav icon-p12">
                          My Gradesheet
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/Opportunities"
                        onClick={closedropdownprofile}
                      >
                        <span className="pro-text-nav">
                          <EmojiPeopleIcon className="icon-p" />
                          Opportunities For You
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/helpdesk"
                        onClick={closedropdownprofile}
                      >
                        <img
                          width="30"
                          height="30"
                          src="/assets/images/icons/help.svg"
                        />
                        <span className="pro-text-nav icon-p12">
                          {/* <LiveHelpIcon className="icon-p" /> */}
                          Help Desk
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/linkedinjobs"
                        onClick={closedropdownprofile}
                      >
                        {/* <LinkedInIcon className="icon-p" /> */}
                        <img
                          width="25"
                          height="30"
                          src="/assets/images/icons/linkedIn.svg"
                        />
                        <span className="pro-text-nav icon-p1">
                          Linkedin Jobs
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      {/* <NavLink onClick={closedropdownprofile}>
                        <SettingsIcon className="icon-p" />
                        <span className="pro-text-nav">Setting</span>
                      </NavLink> */}
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/uploaddocument"
                        onClick={closedropdownprofile}
                      >
                        <AttachFileIcon className="icon-p" />

                        <span className="pro-text-nav icon-p12">Documents</span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        to="/changepswd"
                        onClick={closedropdownprofile}
                      >
                        <img
                          width="30"
                          height="30"
                          src="/assets/images/icons/password.svg"
                        />
                        <span className="pro-text-nav icon-p12">
                          Change Password
                          {/* <VpnKeyIcon className="icon-p" /> */}
                        </span>
                      </NavLink>
                      <hr style={{ margin: "0px" }} />
                      <NavLink
                        tag={Link}
                        onClick={function (event) {
                          context.setUser(null);
                          localStorage.clear();

                          // return<Redirect to="/Signin"/>
                          // props.history.push("/");
                        }}
                      >
                        <ExitToAppIcon className="icon-p" />
                        <span className="pro-text-nav">Logout</span>
                      </NavLink>
                    </span>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </>
          ) : (
            <>
              {/* <NavItem>
                <NavLink
                  tag={Link}
                  to="/Signup"
                  className=" nav-link course-link dropdown-toggle"
                >
                  Courses
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/aboutpage" className="">
                  About
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/become-an-instructor" className="">
                  Become an Instructor
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to="/Signin"
                  className=" nav-link join-now-link"
                >
                  Login
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to="/Signup"
                  className=" nav-link join-now-link"
                >
                  Join Now
                </NavLink>
              </NavItem> */}
            </>
          )}
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default Header;
